import React from "react";
import { 
  FaSyncAlt, FaTools, FaDesktop, FaChalkboardTeacher, 
  FaCogs, FaRegHandshake, FaCheckCircle, FaLock 
} from 'react-icons/fa';
import "./OurService.css";

const OurService = () => {
  return (
    <div className="our-services-wrapper">
      {/* ── Hero Section ── */}
      <header className="services-hero">
        <div className="services-hero-content">
          <h1>Comprehensive Tally Services</h1>
          <p>
            From seamless synchronization to expert corporate training, 
            we provide the end-to-end support your business needs to thrive with TallyPrime.
          </p>
        </div>
      </header>

      {/* ── Services Grid ── */}
      <section className="services-grid-container">
        <div className="services-grid">
          <ServiceCard 
            icon={<FaTools />}
            title="On-Site Support"
            description="Direct, hands-on assistance from experienced technicians for setup, customization, and troubleshooting at your location."
          />
          <ServiceCard 
            icon={<FaDesktop />}
            title="Remote Assistance"
            description="Fast and efficient remote solutions for technical problems, ensuring minimal downtime and rapid error resolution."
          />
          <ServiceCard 
            icon={<FaChalkboardTeacher />}
            title="Corporate Training"
            description="Meticulously crafted training programs designed to help your team master accounting, inventory, and payroll."
          />
          <ServiceCard 
            icon={<FaCogs />}
            title="Tally Implementation"
            description="Expert-led integration of Tally into your organization's workflow, including data migration and best practice guidance."
          />
          <ServiceCard 
            icon={<FaRegHandshake />}
            title="Consultation"
            description="In-depth analysis of your business processes with personalized recommendations to optimize your Tally usage."
          />
          <ServiceCard 
            icon={<FaSyncAlt />}
            title="AMC Sync"
            description="Secure data synchronization between head offices and branches using encrypted client-server environments."
          />
        </div>
      </section>

      {/* ── Detailed Narrative Section (AMC Sync Example) ── */}
      <section className="service-details-container">
        <div className="service-detail-block">
          <h2><FaSyncAlt /> AMC Synchronization & Connectivity</h2>
          <div className="detail-content-grid">
            <div className="detail-text">
              <p>
                Share data seamlessly between multiple instances of TallyPrime using a robust 
                client-server environment. Our synchronization service allows for both 
                on-demand and real-time alignment, ensuring your head office and branches 
                stay perfectly in sync without the need for manual coordination.
              </p>
              <p>
                <strong>On-Demand Synchronization:</strong> Systems align to the Tally.NET 
                Synchronization Service independently, allowing each point to complete its work 
                without clashing with others. This significantly increases the scale of 
                simultaneous uploads across multiple locations.
              </p>
              <div className="detail-highlight-box">
                <h4><FaLock /> Advanced Data Security</h4>
                <p>
                  Transmission is fully secured using encrypted XML over HTTP. 
                  Our proprietary Modified DES algorithms ensure that your sensitive 
                  financial data is never stored on intermediate servers during the exchange.
                </p>
              </div>
            </div>
            <div className="detail-visual">
               {/* Optional image or info card could go here */}
               <div className="detail-highlight-box">
                 <h4>Key Benefits</h4>
                 <ul className="tss-feature-list" style={{listStyle:'none', padding:0}}>
                    <li style={{display:'flex', gap:'10px', marginBottom:'15px'}}>
                      <FaCheckCircle style={{color:'var(--brand)', flexShrink:0}} />
                      <span>Propagated delete actions for consistency</span>
                    </li>
                    <li style={{display:'flex', gap:'10px', marginBottom:'15px'}}>
                      <FaCheckCircle style={{color:'var(--brand)', flexShrink:0}} />
                      <span>Centralized master data control</span>
                    </li>
                    <li style={{display:'flex', gap:'10px', marginBottom:'15px'}}>
                      <FaCheckCircle style={{color:'var(--brand)', flexShrink:0}} />
                      <span>Encrypted XML over HTTP transmission</span>
                    </li>
                 </ul>
               </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div className="service-card">
      <div className="service-icon-wrapper">
        {icon}
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default OurService;
